import React from "react";
import Checkoutsection from "../Components/Checkout/Checkoutsection";
import { useEffect } from "react";
import ProgressTracker from "../Components/Progresstracker/ProgressTracker.js";
import SpecialProducts from "../Components/Productdetails/SpecialProducts.js";
import AOS from "aos";
import "aos/dist/aos.css";
function Checkoutscreen() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    
    AOS.init({
      once: false,
    });

    const handleScroll = () => {
      AOS.refresh();
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <ProgressTracker currentStep={2} />
      <Checkoutsection />
      <SpecialProducts />
    </>
  );
}

export default Checkoutscreen;
